<template>
  <div class="contact-detail">
    <div class="header">
        <div class="action-container">
          <div class="content-left">
            <a @click="navigateBack">
              <a-icon type="left" />Contacts
            </a>
          </div>
          <div class="content-right">
              <a class="download-button" @click="download">
                <a-icon type="download" />
                Download
              </a>
          </div>
        </div>
        <div class="contact-overview">
          <div class="avatar-container">
            <a-avatar v-if="contact.thumbnailUrl" :src="contact.thumbnailUrl" :size="90" />
            <a-avatar v-if="!contact.thumbnailUrl" icon="user" :size="90" />
          </div>

          <div class="text-container">
            <div class="name">
              {{contact.firstname}} {{contact.lastname}}
            </div>
            <div class="cohort">
              {{contact.cohort || '&nbsp;'}}
            </div>
            <div class="buttons">
                <a v-if="contact.homePhone" :href="'tel: ' + contact.homePhone">
                  <a-button type="primary" shape="circle" icon="phone"></a-button>
                </a>
                <a v-if="contact.workEmail" @click="openMailLink(contact.workEmail)">
                  <a-button type="primary" shape="circle" icon="mail"></a-button>
                </a>
            </div>
          </div>
        </div>
    </div>

    <div class="section">
      <div class="section-title">General</div>

      <div class="entry">
        <div class="entry-label">Name</div>
        <div class="entry-value">
          {{ contact.firstname }}
          {{ contact.middlename }}
          {{ contact.lastname }}
        </div>
      </div>
      <div class="entry">
        <div class="entry-label">Gender</div>
        <div class="entry-value">
          {{ contact.gender }}
        </div>
      </div>
      <div class="entry">
        <div class="entry-label">Nationality</div>
        <div class="entry-value">
          {{ contact.nationality }}
        </div>
      </div>
      <div class="entry">
        <div class="entry-label">birthday</div>
        <div class="entry-value">
          {{ birthdayString }}
        </div>
      </div>
    </div>

    <div v-if="contact" class="section contact-info-container">
      <div class="section-title">
        Contact
      </div>
      <div class="entry">
        <div class="entry-label">Phone</div>
        <div class="entry-value">
          <a v-if="contact.homePhone" :href="'tel: ' + contact.homePhone">
            {{ contact.homePhone }}
          </a>
          <span v-else>-</span>
          &nbsp;
        </div>
      </div>
      <div class="entry">
        <div class="entry-label">Phone (Work)</div>
        <div class="entry-value">
          <a v-if="contact.workPhone" :href="'tel: ' + contact.workPhone">
            {{ contact.workPhone }}
          </a>
          <span v-else>-</span>
          &nbsp;
        </div>
      </div>
      <div class="entry">
        <div class="entry-label">CDTM Email</div>
        <div class="entry-value">
          <a v-if="contact.workEmail" @click="openMailLink(contact.workEmail)">
            {{ contact.workEmail }}
          </a>
          <span v-else>-</span>
          &nbsp;
        </div>
      </div>
      <div class="entry">
        <div class="entry-label">Email</div>
        <div class="entry-value">
          <a v-if="contact.email" @click="openMailLink(contact.email)">
            {{ contact.email }}
          </a>
          <span v-else>-</span>
          &nbsp;
        </div>
      </div>
    </div>

    <div v-if="contact.address" class="section address-container">
      <div class="section-title">
        Address
      </div>
      <a target="_blank" :href="'http://maps.google.com/maps?q=' + contact.address.street + ', ' + contact.address.zip + ' ' + contact.address.city + ' ' + contact.address.country">
        <div>{{contact.address.street}}</div>
        <div v-if="contact.address.info">{{contact.address.info}}</div>
        <div>{{contact.address.zip}} {{contact.address.city}}</div>
        <div v-if="contact.address.region">{{contact.address.region}}</div>
        <div v-if="contact.address.country">{{contact.address.country}}</div>
      </a>
    </div>

    <div v-if="contact.emergencyContact" class="section emergency-contact-container">
      <div class="section-title">
        Emergency Contact
      </div>
      <div class="entry">
        <div class="entry-label">Name</div>
        <div class="entry-value">
          <span v-if="contact.emergencyContact.name">
            {{ contact.emergencyContact.name }} 
          </span>
          <span v-else>-</span>
          <span v-if="contact.emergencyContact.affiliation"> 
            ({{contact.emergencyContact.affiliation}})
          </span>
        </div>
      </div>
      <div class="entry">
        <div class="entry-label">Phone</div>
        <div class="entry-value">
          <a v-if="contact.emergencyContact.phone" :href="'tel: ' + contact.emergencyContact.phone">
            {{ contact.emergencyContact.phone }}
          </a>
          <span v-else>-</span>
          &nbsp;
        </div>
      </div>
      <div class="entry">
        <div class="entry-label">Email</div>
        <div class="entry-value">
          <a v-if="contact.emergencyContact.email" @click="openMailLink(contact.emergencyContact.email)">
            {{ contact.emergencyContact.email }}
          </a>
          <span v-else>-</span>
          &nbsp;
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { parse } from 'date-fns'
import vcard from 'vcard-generator'
import { saveAs } from 'file-saver'

export default {
  props: {
    contact: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      profilePictureDataUri: null
    }
  },
  mounted () {
    // doesn't work because of CORS
    // this.getProfilePictureDataUri((error, result) => {
    //   if (!error) {
    //     this.profilePictureDataUri = result
    //   }
    //   this.profilePictureDataUri = null
    // })
  },
  watch: {
    contact () {
      // doesn't work because of CORS
      // this.getProfilePictureDataUri((error, result) => {
      //   if (!error) {
      //     this.profilePictureDataUri = result
      //   }
      //   this.profilePictureDataUri = null
      // })
    }
  },
  computed: {
    birthday () {
      if (!this.contact.birthday) {
        return null
      }

      return parse(this.contact.birthday)
    },
    birthdayString () {
      if (!this.birthday) {
        return '-'
      }

      return this.birthday.toLocaleDateString()
    },
    vCardBirthday () {
      if (!this.birthday) {
        return null
      }

      return {
        year: this.birthday.getFullYear(),
        month: this.birthday.getMonth() + 1,
        day: this.birthday.getDate()
      }
    },
    vCardPhotos () {
      if (this.profilePictureDataUri) {
        return [
          {
            type: 'home',
            dataUri: this.profilePictureDataUri
          }
        ]
      } else {
        return [
          {
            type: 'home',
            dataUri: this.contact.thumbnailUrl
          }
        ]
      }
    },
    vcardContent () {
      return vcard.generate({
        name: {
          familyName: this.contact.lastname,
          givenName: this.contact.firstname,
          middleName: this.contact.middlename,
          prefix: this.contact.gender === 'male' ? 'Mr.' : 'Ms.'
        },
        works: [{
          organization: 'CDTM',
          title: this.contact.cohort,
          role: 'Student'
        }],
        emails: [{
          type: 'work',
          text: this.contact.workEmail
        }, {
          type: 'home',
          text: this.contact.email
        }],
        phones: [
          {
            type: 'home',
            text: this.contact.homePhone
          }, {
            type: 'work',
            text: this.contact.workPhone
          }
        ],
        addresses: [
          {
            type: 'home',
            street: this.contact.address && this.contact.address.street,
            locality: this.contact.address && this.contact.address.city,
            region: this.contact.address && this.contact.address.region,
            info: this.contact.address && this.contact.address.info,
            code: this.contact.address && this.contact.address.zip,
            country: this.contact.address && this.contact.address.country
          }
        ],
        urls: [{
          type: 'personal',
          uri: this.contact.url
        }, {
          type: 'cdtm',
          uri: this.contact.workUrl
        }],

        photos: this.vCardPhotos,
        birthday: this.vCardBirthday,
        gender: {
          sex: this.contact.gender
        }
      })
    }
  },
  methods: {
    navigateBack () {
      this.$router.push('/contacts')
    },
    parse (val) {
      return parse(val)
    },
    openMailLink (mail) {
      window.open(`mailto:${mail}`)
    },
    openPhoneLink (phone) {
      window.open(`tel:${phone}`, '_system')
    },
    getProfilePictureDataUri (callback) {
      if (!this.contact.thumbnailUrl) {
        return callback(null, null)
      }

      fetch(this.contact.thumbnailUrl)
        .then(r => r.blob()).then(blob => {
          let reader = new FileReader()
          reader.onload = () => {
            let b64 = reader.result.replace(/^data:.+;base64,/, '')
            callback(null, `${b64.slice(0, 20)}...${b64.slice(-20)}`)
          }
          reader.readAsDataURL(blob)
        })
        .catch((error) => {
          callback(error, null)
          throw error
        })
    },
    download () {
      let blob = new File([String(this.vcardContent)], {type: 'application/octet-stream'})
      saveAs(blob, `${this.contact.lastname}.vcard`)
    }
  }
}
</script>

<style scoped>
.contact-detail{
  padding: 10px;
}

.contact-detail a {
  cursor: pointer;
}

.header {
  padding-bottom: 10px;
  border-bottom: 1px solid #e8e8e8;
}

.header a {
  cursor: pointer;
}

.action-container {
	display: -ms-flex;
	display: -webkit-flex;
	display: flex;
  padding: 10px 0;
}

.action-container > div {
	width: 50%;
	padding: 10px;
}

.action-container .content-left,
.action-container .content-right {
    display: flex;
    font-size: 16px;
}

.action-container .content-left {
    justify-content: flex-start;
}

.action-container .content-right {
    justify-content: flex-end;
}

.contact-overview {
  margin-top: 10px
}

.avatar-container {
  display: inline-block;
  overflow: hidden;
}

.text-container {
  padding-left: 15px;
  display: inline-block;
  vertical-align: top;
}

.text-container .name {
  font-weight: bold;
  font-size: 16px;
}

.text-container .cohort {
  font-size: 14px;
}

.text-container .buttons {
  margin-top: 10px;
}

.text-container .buttons .ant-btn-circle {
    width: 28px;
    height: 28px;
    font-size: 14px;
    margin-right: 10px;
}

.section {
  margin: 10px 0;
  padding-bottom: 10px;
  border-bottom: 1px dashed #e8e8e8;
}

.section-title {
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 6px
}

.entry {
  margin-bottom: 6px;
}

.entry .entry-label {
  font-size: 12px;
  line-height: 12px;
}

.entry .entry-value {
  color: black;
}

</style>



// WEBPACK FOOTER //
// src/components/ContactDetail.vue